import * as React from "react";

interface TestingAssistContextProviderState {
    complianceDate: string | undefined;
    setComplianceDate: React.Dispatch<React.SetStateAction<string>>;
    visitStartDate: string | undefined;
    setVisitStartDate: React.Dispatch<React.SetStateAction<string>>;
}

export const TestingAssistContext = React.createContext<TestingAssistContextProviderState | undefined>(undefined);

interface TestingAssistContextProps {
    children: React.ReactNode;
}

export const TestingAssistContextProvider = ({ children }: TestingAssistContextProps) => {
    const [complianceDate, setComplianceDate] = React.useState<string | undefined>();
    const [visitStartDate, setVisitStartDate] = React.useState<string | undefined>();


    return (
        <TestingAssistContext.Provider value={{
            complianceDate: complianceDate,
            setComplianceDate: setComplianceDate,
            visitStartDate: visitStartDate,
            setVisitStartDate: setVisitStartDate
            }}
        >
            {children}
        </TestingAssistContext.Provider>
    );
}

export const useTestingAssistContextProvider = () => {
    const context = React.useContext(TestingAssistContext);
    if (context === undefined) {
        throw new Error('useTestingAssistContextProvider must be used within a TestingAssistContext Provider')
    }

    return context;
}
